<template>
  <WrapperCell
      code="benefit_coupon"
      :icon="ICONS.promocode"
      label="Промокод"
      :active="active"
      :model-value="coupon"
      :mode="mode"
  >
    <template v-if="coupon">
      {{ coupon.NAME }}
    </template>
  </WrapperCell>
</template>

<script lang="ts" setup>

import {ICONS} from "@/assets/icons";
import WrapperCell from "@/components/Shop/VOrder/ui/Section/Wrapper/WrapperCell.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {storeToRefs} from "pinia";
import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import {useVorderCoupon} from "@/modules/shop/store/vorder-coupon";

const vorderState = useVorderState()
const vorderCoupon = useVorderCoupon()
const stackRouter = useStackRouter()

const {coupon} = storeToRefs(vorderCoupon)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})


</script>

<style scoped>

</style>
